import client from '../config/AxiosConfig'

export const GetSuggestedLessons = async () =>
  client.get('/lessons/suggested')

export const GetGuidedJourneys = async (page, limit) =>
  client.get(`/lessons/suggested/${page}/${limit}`)
